import React from 'react';
import { useNavigate } from 'react-router-dom';
import useUser from '../../Hooks/useUser.js';
import { EyeIcon } from '@heroicons/react/24/solid';

export const ImpersonateView = () => {
  const { impersonateEmail, setImpersonateEmail, handleUserViewChange } = useUser();
  const navigate = useNavigate();

  return (
    <div
      className={`from-pdred to-pdorange relative isolate flex flex-col items-center gap-x-6 overflow-hidden bg-gradient-to-r px-6 py-2.5 sm:px-3.5 sm:before:flex-1`}
    >
      <div className="flex flex-wrap items-center gap-x-4 gap-y-2">
        <span className="flex">
          <div className="flex flex-col self-center">
            <EyeIcon className="size-12" />
          </div>
          <div className="mx-4 flex flex-none flex-col items-center text-lg lg:flex-row lg:text-2xl">
            Logged in as <span className="flex text-lg font-semibold lg:ml-2 lg:text-2xl">{impersonateEmail}</span>
          </div>
        </span>
        <span
          onClick={() => {
            setImpersonateEmail('');
            handleUserViewChange(false);
            navigate('/users');
          }}
          className="flex-none cursor-pointer rounded-full bg-gray-900 px-2 py-0.5 text-xl font-semibold text-white shadow-xs"
        >
          Exit
        </span>
      </div>
    </div>
  );
};
